// extracted by mini-css-extract-plugin
var _1 = "SymbolItem_root__8df62";
export { _1 as "root" }
